import React from "react"


export default function TodoImg({img}) {
return(
    <img
    src={img}
    className="avatar"
    alt=""
    // style={{width:"90px",height:"90px",borderRadius: "50%", animation: "App-logo-spin infinite 20s linear"}}
  />
)}